var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7693 11.205C24.7693 11.205 23.9351 21.3149 23.4649 25.5599C23.4371 26.4498 23.0549 27.2928 22.4015 27.9053C21.7481 28.5178 20.8764 28.8502 19.9763 28.83H19.8853C15.9264 28.83 11.9676 28.905 8.0088 28.83C7.12471 28.8584 6.26512 28.5402 5.61733 27.9445C4.96954 27.3488 4.58607 26.5241 4.55051 25.65C4.06514 21.36 3.24609 11.2801 3.24609 11.2801",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8626 6.36003H1.07715",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9027 6.36004C21.3268 6.36057 20.7685 6.16338 20.3232 5.8023C19.8778 5.44121 19.573 4.9385 19.4606 4.37994L19.0814 2.54998C18.9739 2.14167 18.7324 1.78029 18.3948 1.52239C18.0571 1.26449 17.6424 1.12473 17.2158 1.12505H10.7997C10.3711 1.12397 9.95425 1.26316 9.61404 1.52093C9.27382 1.77869 9.02941 2.14047 8.91892 2.54998L8.53972 4.37994C8.42735 4.9385 8.12247 5.44121 7.67712 5.8023C7.23178 6.16338 6.67354 6.36057 6.09766 6.36004",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash-bin.4e022c3098d0e771b5985b5d724366b6.svg";
export { ForwardRef as ReactComponent };